package pl.finn.forms.model

import kotlinx.serialization.Serializable
import pl.finn.forms.enums.*

@Serializable
data class DocumentTreeNode(
  var id: String = "",
  var name: String? = null,
  var type: NodeType? = null
) {
  var children = ArrayList<DocumentTreeNode?>()
  var choiceLabels: Array<Array<String?>?>? = null
  var label: String? = null
  var namespace: String? = null
  var parent: DocumentTreeNode? = null
  var typeName: String? = null
  var typeNamespace: String? = null
  var value: String? = null
  var maxOccurs: Int? = null
  var metaModel: MetaModel? = null
}

@Serializable
data class MetaModel(
  val id: String? = null,
) {
  var controlType: ControlType? = null
  var choiceView: ArrayList<ChoiceModel?>? = null
  var enumValues: Array<String?>? = null
  var footer: String? = null
  var footerClass: StyleClass? = null
  var header: String? = null
  var hidden: Boolean? = null
  var headerClass: StyleClass? = null
  var help: String? = null
  var html: String? = null
  var inputSize: Int? = null
  var label: String? = null
  var nodeName: String? = null
  var nodeQName: String? = null
  var particleView: ArrayList<ParticleModel?>? = null
  var validationMessage: String? = null
  var value: String = ""
  var viewType: ViewType? = null
  var isElementRequired: Boolean? = null
  var labelArray: Array<String?>? = null
}

@Serializable
data class ChoiceModel(
  val id: String? = null
) {
  var bindedAs: BindedAs? = null
  var help: String? = null
  var labels: Array<String?>? = null
  var selected: Int? = null
  var isDisabled: Boolean? = null
}

@Serializable
data class ParticleModel(
  val bindingStyle: ParticleFor? = null
) {
  var addButtonName: String? = null
  var bindedAs: BindedAs? = null
  var label: String? = null
  var removeButtonName: String? = null
  var isCheckbox: Boolean? = null
}